import React from 'react';

import 'bootstrap/dist/css/bootstrap.min.css';
import './SocialMediaBar.css'

import { Container } from 'react-bootstrap'

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faLinkedin, faGithub, faYoutube, faDiscord, faInstagram, faTiktok, faTwitch, faXTwitter } from '@fortawesome/free-brands-svg-icons'

const SocialMediaBar = () => {
  return (
    <div className="social-media-bar">
      <Container>
        <div className='single-col social-media-icons-white d-flex justify-content-evenly fa-4x'>
          <a href="https://www.linkedin.com/in/eric-kurachi/" target="_blank" rel="noopener noreferrer">
            <FontAwesomeIcon icon={faLinkedin} />
          </a>
          <a href="https://github.com/EricKurachi" target="_blank" rel="noopener noreferrer">
            <FontAwesomeIcon icon={faGithub} />
          </a>
          <a href="https://www.youtube.com/channel/UCLN0lEdo6TT61Jn9jTpzFpA" target="_blank" rel="noopener noreferrer">
            <FontAwesomeIcon icon={faYoutube} />
          </a>
          <a href="https://discord.gg/8wZpmBc8EN" target="_blank" rel="noopener noreferrer">
            <FontAwesomeIcon icon={faDiscord} />
          </a>
          <a href="https://www.instagram.com/eric.kurachi/" target="_blank" rel="noopener noreferrer">
            <FontAwesomeIcon icon={faInstagram} />
          </a>
          <a href="https://www.tiktok.com/@eric.kurachi" target="_blank" rel="noopener noreferrer">
            <FontAwesomeIcon icon={faTiktok} />
          </a>
          <a href="https://www.twitch.tv/kitakinho" target="_blank" rel="noopener noreferrer">
            <FontAwesomeIcon icon={faTwitch} />
          </a>
          <a href="https://x.com/kitakinho" target="_blank" rel="noopener noreferrer">
            <FontAwesomeIcon icon={faXTwitter} />
          </a>
        </div>
      </Container>

    </div>
  );
};

export default SocialMediaBar;